import { render, staticRenderFns } from "./ResetPasswordForm.vue?vue&type=template&id=1a3ed28e&scoped=true"
import script from "./ResetPasswordForm.vue?vue&type=script&lang=js"
export * from "./ResetPasswordForm.vue?vue&type=script&lang=js"
import style0 from "./ResetPasswordForm.vue?vue&type=style&index=0&id=1a3ed28e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a3ed28e",
  null
  
)

export default component.exports